var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{class:{ 'opacity-50 cursor-not-allowed': _vm.disabled },on:{"click":_vm.handleClick}},[_c('Icon',{class:_vm.iconClass,attrs:{"icon":_vm.icon,"disabled":_vm.disabled}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }